export interface EventScheduleItem {
  time: string;
  title: string;
  detail: string;
}

export interface EventStatItem {
  label: string;
  value: string;
}

export interface EventItem {
  id: string;
  title: string;
  category: string;
  region: string;
  date: string;
  startDate: string;
  cover: string;
  summary: string;
  description: string;
  format: string;
  venue: string;
  teams: string[];
  tags: string[];
  heat: number;
  status: string;
  schedule: EventScheduleItem[];
  stats: EventStatItem[];
}

export const eventCategories = [
  "全部类型",
  "电子竞技",
  "体育竞技",
  "棋牌竞技",
  "极限运动",
];

export const eventRegions = [
  "全部地区",
  "全国",
  "华东",
  "华北",
  "华南",
  "华中",
  "西南",
  "海外",
];

export const eventTags = [
  "夺冠热门",
  "国际赛事",
  "新秀登场",
  "经典对决",
  "决赛日",
  "焦点直播",
];

export const eventStatusList = ["全部状态", "进行中", "报名中", "已结束"];

export const events: EventItem[] = [
  {
    id: "wcg-asia-2026",
    title: "WCG 亚洲邀请赛 2026 总决赛",
    category: "电子竞技",
    region: "华东",
    date: "2026-10-12 至 10-18",
    startDate: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=esports%20grand%20final%20stage%20with%20large%20LED%20screens%2C%20neon%20spotlights%2C%20huge%20crowd%20in%20dark%20arena%2C%20cinematic%20dramatic%20lighting%2C%20professional%20photography%2C%20cool%20warm%20contrast&width=1280&height=800&seq=event-wcg-asia&orientation=landscape",
    summary:
      "亚洲四大赛区顶尖战队齐聚上海，争夺年度总冠军奖杯，赛程为期一周，采用双败淘汰制。",
    description:
      "WCG 亚洲邀请赛 2026 总决赛是本年度亚洲规模最大的综合性电竞赛事。来自中国、韩国、日本及东南亚赛区的十六支顶级战队将在为期七天的赛程中展开激烈角逐。赛事采用双败淘汰赛制，每一场比赛都关系到能否继续留在舞台之上。开幕日将率先进行小组循环赛，随后进入残酷的淘汰阶段。组委会同时公布了全新的赛事规则与选边机制，力求为观众呈现更高水准的对抗。",
    format: "英雄联盟 5v5",
    venue: "上海梅赛德斯奔驰文化中心",
    teams: ["旭日战队", "星海电竞", "暗夜联盟", "雷霆战神"],
    tags: ["夺冠热门", "国际赛事", "焦点直播"],
    heat: 98,
    status: "进行中",
    schedule: [
      { time: "10-12 14:00", title: "小组赛 A 组", detail: "旭日战队 vs 星海电竞" },
      { time: "10-13 16:00", title: "小组赛 B 组", detail: "暗夜联盟 vs 雷霆战神" },
      { time: "10-15 18:00", title: "胜者组半决赛", detail: "A 组头名 vs B 组第二名" },
      { time: "10-18 19:30", title: "总决赛", detail: "胜者组冠军 vs 败者组冠军" },
    ],
    stats: [
      { label: "参赛队伍", value: "16 支" },
      { label: "比赛场次", value: "46 场" },
      { label: "总奖金", value: "¥ 800 万" },
    ],
  },
  {
    id: "kpl-autumn-final",
    title: "KPL 王者荣耀秋季赛 总决赛",
    category: "电子竞技",
    region: "华南",
    date: "2026-10-15",
    startDate: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=mobile%20esports%20tournament%20stage%20with%20orange%20and%20dark%20blue%20lighting%2C%20two%20teams%20competing%2C%20big%20screen%20scoreboard%2C%20energetic%20arena%20atmosphere%2C%20cinematic%20sports%20photography&width=1280&height=800&seq=event-kpl-final&orientation=landscape",
    summary:
      "本年度 KPL 最强两支队伍在总决赛舞台正面对决，争夺银龙杯与年度总冠军荣耀。",
    description:
      "KPL 王者荣耀秋季赛总决赛将于 10 月 15 日在深圳春茧体育馆拉开帷幕。常规赛表现最为稳定的两支队伍会师决赛，一方以稳健的战术运营著称，另一方则以激进的团战风格闻名。双方在本赛季的三次交手中互有胜负，总决赛的胜负天平仍未明朗。赛前官方公布了全新的比赛版本与英雄平衡调整，为这场巅峰对决增添了更多悬念。",
    format: "王者荣耀 5v5",
    venue: "深圳湾体育中心春茧体育馆",
    teams: ["逐梦之星", "赤焰战队"],
    tags: ["经典对决", "决赛日", "焦点直播"],
    heat: 94,
    status: "报名中",
    schedule: [
      { time: "10-15 15:00", title: "开幕式", detail: "战队入场与赛季回顾" },
      { time: "10-15 16:00", title: "第一局", detail: "逐梦之星 vs 赤焰战队" },
      { time: "10-15 18:30", title: "第二至第五局", detail: "BO7 决胜" },
      { time: "10-15 21:00", title: "颁奖典礼", detail: "银龙杯授予仪式" },
    ],
    stats: [
      { label: "赛制", value: "BO7" },
      { label: "历史交手", value: "3 次" },
      { label: "总奖金", value: "¥ 1200 万" },
    ],
  },
  {
    id: "cs2-major-shanghai",
    title: "CS2 上海 Major 小组赛",
    category: "电子竞技",
    region: "华东",
    date: "2026-10-09 至 10-20",
    startDate: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=tactical%20shooter%20esports%20arena%20with%20blue%20spotlights%20and%20smoke%2C%20competitive%20team%20players%20at%20desks%2C%20dramatic%20dark%20stage%20lighting%2C%20cinematic%20broadcast%20photography&width=1280&height=800&seq=event-cs2-major&orientation=landscape",
    summary:
      "来自全球的二十四支战队在上海争夺 Major 冠军，小组赛阶段爆冷与逆转不断上演。",
    description:
      "CS2 上海 Major 是年度最重要的国际级战术射击赛事之一。二十四支战队分为四个小组进行循环对抗，只有在小组赛中取得足够胜场的队伍才能晋级淘汰赛。本届赛事看点十足：多支传统豪门在小组赛中遭遇顽强的挑战者，冷门与逆转轮番上演。解说团队对地图池的战术演变展开了深入分析，观众可以在每场比赛后查看详细的数据统计。",
    format: "CS2 5v5",
    venue: "上海东方体育中心",
    teams: ["北境之狼", "铁血军团", "极光战队", "红隼联盟"],
    tags: ["国际赛事", "新秀登场"],
    heat: 91,
    status: "进行中",
    schedule: [
      { time: "10-09 12:00", title: "小组赛第一轮", detail: "四场同时进行" },
      { time: "10-12 14:00", title: "小组赛第二轮", detail: "关键出线战" },
      { time: "10-16 18:00", title: "小组赛收官", detail: "最后晋级名额争夺" },
      { time: "10-20 19:00", title: "淘汰赛开赛", detail: "八强对阵出炉" },
    ],
    stats: [
      { label: "参赛队伍", value: "24 支" },
      { label: "地图池", value: "7 张" },
      { label: "总奖金", value: "$ 125 万" },
    ],
  },
  {
    id: "dota2-ti-qualifier",
    title: "DOTA2 国际邀请赛 中国区预选赛",
    category: "电子竞技",
    region: "华中",
    date: "2026-10-11 至 10-14",
    startDate: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=moba%20esports%20tournament%20stage%20with%20dramatic%20red%20and%20dark%20lighting%2C%20five%20players%20focused%20on%20screens%2C%20grand%20arena%20with%20huge%20crowd%2C%20cinematic%20sports%20photography&width=1280&height=800&seq=event-dota2-ti&orientation=landscape",
    summary:
      "国内顶尖 DOTA2 战队争夺国际邀请赛正赛席位，胜者将代表中国赛区出征国际舞台。",
    description:
      "DOTA2 国际邀请赛中国区预选赛汇集了国内排名前列的六支战队。赛事采用双败淘汰制，最终排名第一的队伍将直接获得正赛席位。预选赛向来以战术深度著称，各队教练组往往会在赛前准备大量独特的分路与出装套路。本届预选赛的最大看点在于几支新生代战队能否打破老牌强队的统治格局。",
    format: "DOTA2 5v5",
    venue: "武汉体育中心",
    teams: ["巨龙之魂", "苍穹战队", "荒原猎手", "晨曦联盟"],
    tags: ["新秀登场", "经典对决"],
    heat: 86,
    status: "进行中",
    schedule: [
      { time: "10-11 13:00", title: "胜者组首轮", detail: "六队捉对厮杀" },
      { time: "10-12 15:00", title: "败者组首轮", detail: "背水一战" },
      { time: "10-13 16:00", title: "胜者组决赛", detail: "正赛席位之争" },
      { time: "10-14 18:00", title: "预选赛决赛", detail: "最后的晋级机会" },
    ],
    stats: [
      { label: "参赛队伍", value: "6 支" },
      { label: "晋级名额", value: "1 个" },
      { label: "赛制", value: "双败淘汰" },
    ],
  },
  {
    id: "valorant-champions",
    title: "无畏契约 冠军巡回赛 亚太赛区",
    category: "电子竞技",
    region: "海外",
    date: "2026-10-13 至 10-19",
    startDate: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20esports%20arena%20with%20teal%20and%20orange%20stage%20lighting%2C%20tactical%20shooter%20players%20at%20competition%20desks%2C%20dramatic%20broadcast%20lighting%2C%20cinematic%20photography&width=1280&height=800&seq=event-valorant&orientation=landscape",
    summary:
      "亚太赛区十二支强队争夺冠军巡回赛积分，赛事横跨多国线上对抗与线下总决赛。",
    description:
      "无畏契约冠军巡回赛亚太赛区汇聚了来自中国、韩国、日本、东南亚及大洋洲的队伍。赛事分为线上小组赛与线下总决赛两个阶段，最终排名靠前的队伍将获得年度冠军赛的参赛资格。本赛季多支战队引入了全新的阵容组合，战术风格更加多变，中远距离的对枪与残局处理成为决定胜负的关键。",
    format: "无畏契约 5v5",
    venue: "首尔电竞竞技场",
    teams: ["霓虹先锋", "苍穹守卫", "暗影猎手", "极昼战队"],
    tags: ["国际赛事", "焦点直播"],
    heat: 83,
    status: "报名中",
    schedule: [
      { time: "10-13 15:00", title: "线上小组赛", detail: "十二队分为两组" },
      { time: "10-16 17:00", title: "淘汰赛首轮", detail: "八强出炉" },
      { time: "10-18 18:00", title: "半决赛", detail: "四强会师" },
      { time: "10-19 19:00", title: "赛区总决赛", detail: "冠军诞生" },
    ],
    stats: [
      { label: "参赛队伍", value: "12 支" },
      { label: "赛区", value: "亚太" },
      { label: "积分赛", value: "4 站" },
    ],
  },
  {
    id: "cba-preseason",
    title: "CBA 季前赛 焦点对抗赛",
    category: "体育竞技",
    region: "华北",
    date: "2026-10-14",
    startDate: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=professional%20basketball%20game%20in%20a%20bright%20indoor%20arena%2C%20players%20competing%20under%20spotlights%2C%20wooden%20court%2C%20cheering%20crowd%2C%20dynamic%20sports%20photography&width=1280&height=800&seq=event-cba&orientation=landscape",
    summary:
      "CBA 新赛季前的焦点对抗赛，多支球队检验夏窗引援成果，年轻球员迎来表现机会。",
    description:
      "CBA 季前赛焦点对抗赛是新赛季开始前的重要热身舞台。多支球队在休赛期完成了阵容调整，季前赛成为检验引援成果与战术磨合的绝佳机会。教练组普遍会给予年轻球员更多的出场时间，因此这也是观察新星崛起的窗口。比赛将在北京五棵松体育馆进行，门票开售后迅速售罄。",
    format: "篮球 5v5",
    venue: "北京五棵松体育馆",
    teams: ["京城劲旅", "北方雄狮", "海河王者", "齐鲁战神"],
    tags: ["新秀登场", "经典对决"],
    heat: 80,
    status: "报名中",
    schedule: [
      { time: "10-14 15:30", title: "首场对抗", detail: "京城劲旅 vs 北方雄狮" },
      { time: "10-14 19:35", title: "焦点战", detail: "海河王者 vs 齐鲁战神" },
      { time: "10-14 21:30", title: "赛后数据发布", detail: "球员表现统计" },
    ],
    stats: [
      { label: "参赛球队", value: "4 支" },
      { label: "比赛场次", value: "2 场" },
      { label: "场馆容量", value: "18000 人" },
    ],
  },
  {
    id: "china-marathon-cup",
    title: "全国城市马拉松大奖赛 总决赛",
    category: "体育竞技",
    region: "西南",
    date: "2026-10-18",
    startDate: "2026-10-18",
    cover:
      "https://readdy.ai/api/search-image?query=large%20city%20marathon%20race%20with%20thousands%20of%20runners%20on%20wide%20avenue%2C%20morning%20light%2C%20colorful%20event%20banners%2C%20energetic%20atmosphere%2C%20aerial%20sports%20photography&width=1280&height=800&seq=event-marathon&orientation=landscape",
    summary:
      "全国城市马拉松大奖赛收官站落户成都，数万名跑者共同挑战 42.195 公里全马赛道。",
    description:
      "全国城市马拉松大奖赛总决赛将在成都举行，赛道路线串联了城市地标与滨江景观带，兼顾竞技性与观赏性。赛事设置了全程马拉松、半程马拉松与欢乐跑三个项目，满足不同水平跑者的需求。组委会在沿途设置了充足的补给站与医疗保障点，并通过智能计时系统为每位选手提供精准成绩。",
    format: "马拉松 42.195km",
    venue: "成都天府广场",
    teams: ["全程马拉松组", "半程马拉松组", "欢乐跑组"],
    tags: ["决赛日", "焦点直播"],
    heat: 76,
    status: "报名中",
    schedule: [
      { time: "10-18 06:30", title: "选手集结", detail: "检录与热身" },
      { time: "10-18 07:30", title: "全程组起跑", detail: "天府广场出发" },
      { time: "10-18 08:00", title: "半程组起跑", detail: "滨江赛道" },
      { time: "10-18 12:00", title: "颁奖典礼", detail: "各组别优胜者" },
    ],
    stats: [
      { label: "报名人数", value: "32000 人" },
      { label: "赛道长度", value: "42.195 km" },
      { label: "补给站", value: "15 个" },
    ],
  },
  {
    id: "table-tennis-grand",
    title: "全国乒乓球大奖赛 单打决赛",
    category: "体育竞技",
    region: "华中",
    date: "2026-10-16",
    startDate: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=professional%20table%20tennis%20match%20in%20bright%20arena%2C%20player%20in%20mid%20swing%2C%20green%20table%20and%20dark%20blue%20backdrop%2C%20dynamic%20action%20sports%20photography&width=1280&height=800&seq=event-tabletennis&orientation=landscape",
    summary:
      "国内乒乓球顶尖选手会师单打决赛，速度与旋转的巅峰较量一触即发。",
    description:
      "全国乒乓球大奖赛单打决赛汇集了国内排名前列的男女选手。比赛采用七局四胜制，半决赛阶段就已出现多场拉锯战。选手们在发球变化、正手进攻与相持球处理上展现了极高的技术水平。赛事同期还设置了青少年组比赛与球迷互动环节，进一步推动乒乓球运动的普及。",
    format: "乒乓球 单打",
    venue: "郑州奥体中心体育馆",
    teams: ["林峻熙", "赵启明", "陈思远", "周雨桐"],
    tags: ["经典对决", "决赛日"],
    heat: 74,
    status: "报名中",
    schedule: [
      { time: "10-16 14:00", title: "女子半决赛", detail: "两场同时进行" },
      { time: "10-16 16:30", title: "男子半决赛", detail: "强强对话" },
      { time: "10-16 19:30", title: "女子单打决赛", detail: "七局四胜" },
      { time: "10-16 20:30", title: "男子单打决赛", detail: "冠军诞生" },
    ],
    stats: [
      { label: "参赛选手", value: "32 人" },
      { label: "赛制", value: "七局四胜" },
      { label: "比赛用球", value: "40+ 白色" },
    ],
  },
  {
    id: "chess-masters",
    title: "中国国际象棋大师赛 快棋赛",
    category: "棋牌竞技",
    region: "华北",
    date: "2026-10-13",
    startDate: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20chess%20tournament%20hall%20with%20wooden%20chessboard%20and%20pieces%2C%20warm%20ambient%20lighting%2C%20thoughtful%20players%2C%20refined%20interior%2C%20editorial%20photography&width=1280&height=800&seq=event-chess&orientation=landscape",
    summary:
      "国内顶尖棋手在快棋赛中短兵相接，时限压力下每一步都考验计算与心态。",
    description:
      "中国国际象棋大师赛快棋赛采用每方 15 分钟加每步 10 秒的时限规则，节奏紧凑、观赏性强。参赛棋手均为国内高等级分选手，快棋赛中的战术失误往往在瞬间被对手抓住。赛事同期安排了大师讲解与棋迷对弈活动，让观众更深入地理解国际象棋的魅力。",
    format: "国际象棋 快棋",
    venue: "北京棋院",
    teams: ["沈书言", "高屹", "苏婉清", "郑立恒"],
    tags: ["经典对决", "新秀登场"],
    heat: 69,
    status: "进行中",
    schedule: [
      { time: "10-13 10:00", title: "预赛第一轮", detail: "瑞士制七轮" },
      { time: "10-13 14:00", title: "预赛第四轮", detail: "积分争夺" },
      { time: "10-13 17:00", title: "决赛", detail: "前两名直接对话" },
    ],
    stats: [
      { label: "参赛棋手", value: "24 人" },
      { label: "时限", value: "15+10" },
      { label: "赛制", value: "瑞士制" },
    ],
  },
  {
    id: "go-king",
    title: "围棋棋王争霸赛 八强战",
    category: "棋牌竞技",
    region: "华东",
    date: "2026-10-17",
    startDate: "2026-10-17",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20go%20game%20board%20with%20black%20and%20white%20stones%2C%20serene%20study%20room%20with%20soft%20warm%20light%2C%20two%20players%20deep%20in%20thought%2C%20minimal%20elegant%20interior%2C%20editorial%20photography&width=1280&height=800&seq=event-go&orientation=landscape",
    summary:
      "棋王争霸赛八强战落子杭州，职业九段与新锐棋手同台竞技，中盘战斗看点十足。",
    description:
      "围棋棋王争霸赛八强战汇集了国内等级分靠前的八位职业棋手。比赛使用中国规则，每方两小时基本用时。本届赛事中，多位新锐棋手通过预选赛杀入八强，与传统强手展开正面交锋。解说团队将结合 AI 胜率曲线为观众实时呈现局势变化，帮助棋迷理解复杂的全局判断。",
    format: "围棋 个人赛",
    venue: "杭州棋院",
    teams: ["顾言之", "陆清和", "方致远", "许望舒"],
    tags: ["经典对决"],
    heat: 66,
    status: "报名中",
    schedule: [
      { time: "10-17 10:00", title: "八强战上半区", detail: "两盘对局" },
      { time: "10-17 13:30", title: "八强战下半区", detail: "两盘对局" },
      { time: "10-17 17:00", title: "赛后复盘", detail: "AI 胜率解析" },
    ],
    stats: [
      { label: "参赛棋手", value: "8 人" },
      { label: "用时规则", value: "中国规则" },
      { label: "对局数量", value: "4 盘" },
    ],
  },
  {
    id: "skate-open",
    title: "全国极限滑板公开赛 街式决赛",
    category: "极限运动",
    region: "华南",
    date: "2026-10-19",
    startDate: "2026-10-19",
    cover:
      "https://readdy.ai/api/search-image?query=street%20skateboarding%20competition%20with%20skater%20doing%20aerial%20trick%2C%20concrete%20skatepark%20with%20rails%20and%20stairs%2C%20sunny%20afternoon%2C%20dynamic%20action%20sports%20photography&width=1280&height=800&seq=event-skate&orientation=landscape",
    summary:
      "滑板好手在街式赛道展开技巧比拼，高难度动作与稳定发挥共同决定最终排名。",
    description:
      "全国极限滑板公开赛街式决赛在广州滑板公园举行，赛道包含楼梯、扶手、台阶与抛台等经典街式元素。评分将综合考虑动作难度、完成度、连贯性与个人风格。赛事吸引了众多年轻选手参与，他们在赛道上不断挑战更高难度的技巧组合，为观众带来极具冲击力的视觉体验。",
    format: "滑板 街式",
    venue: "广州极限运动公园",
    teams: ["极速少年队", "街头先锋队", "南粤滑板社"],
    tags: ["新秀登场", "焦点直播"],
    heat: 72,
    status: "报名中",
    schedule: [
      { time: "10-19 10:00", title: "预赛", detail: "选手依次出场" },
      { time: "10-19 14:00", title: "决赛第一轮", detail: "最佳动作计分" },
      { time: "10-19 16:00", title: "决赛大绝招", detail: "高难度挑战" },
    ],
    stats: [
      { label: "参赛选手", value: "40 人" },
      { label: "赛道元素", value: "12 处" },
      { label: "评分维度", value: "4 项" },
    ],
  },
  {
    id: "climbing-cup",
    title: "全国攀岩攀石公开赛 总决赛",
    category: "极限运动",
    region: "西南",
    date: "2026-10-20",
    startDate: "2026-10-20",
    cover:
      "https://readdy.ai/api/search-image?query=sport%20climbing%20competition%20with%20athlete%20scaling%20a%20colorful%20indoor%20climbing%20wall%2C%20bright%20modern%20gym%2C%20focused%20athletic%20pose%2C%20dynamic%20sports%20photography&width=1280&height=800&seq=event-climbing&orientation=landscape",
    summary:
      "攀石高手面对精心设计的线路挑战极限，力量、柔韧与线路解读缺一不可。",
    description:
      "全国攀岩攀石公开赛总决赛在贵阳攀岩中心举行。攀石比赛要求选手在规定时间内完成多条难度递增的线路，线路设计刻意考验选手的爆发力、身体控制与读线能力。赛事同时设有难度赛与速度赛项目，全面展示攀岩运动的多样魅力。本次比赛也是观察新生代攀岩选手成长的重要窗口。",
    format: "攀岩 攀石",
    venue: "贵阳攀岩运动中心",
    teams: ["岩壁精灵队", "向上攀岩队", "西南雄鹰队"],
    tags: ["新秀登场", "经典对决"],
    heat: 64,
    status: "报名中",
    schedule: [
      { time: "10-20 09:30", title: "资格赛", detail: "四条线路比拼" },
      { time: "10-20 14:00", title: "半决赛", detail: "晋级名额争夺" },
      { time: "10-20 19:00", title: "决赛", detail: "巅峰对决" },
    ],
    stats: [
      { label: "参赛选手", value: "60 人" },
      { label: "线路数量", value: "12 条" },
      { label: "项目设置", value: "3 项" },
    ],
  },
];